var config = {
    baseurl: "/",
}

export default config;